<template>
    <div class="ChatHeader">
        <div class="questionBox">
            <div class="questionTips" v-if="questionTips!==''">
                <q v-html="questionTips"></q>
            </div>
        </div>
        <div class="topViewWrapper">
            <div class="children" @click="onBlock">
                <img src="../../assets/img/xiaofeng.png" alt="" class="childImg"/>
            </div>
            <div class="loadingBox clear" v-if="chatLoading">
                <img src="../../assets/img/loading1.gif" alt="" class="loadingImg">
            </div>
            <div class="contentCls" v-else>
                <div class="helloXf">
                    <transition enter-active-class="animated bounceInRight">
                        <div v-show="isViewFade">
<!--                            <div class="tipsTodo" v-html="guideTips">-->
<!--                                {{guideTips?"":pageTips}}-->
<!--                            </div>-->
                            <div class="guideTips" v-html="guideTips">
                                {{guideTips?guideTips:pageTipsTo}}
                            </div>
                        </div>
                    </transition>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import {RandomNumBoth} from "@/utils/utils";
    import {mapState, mapActions, mapMutations} from "vuex";
    export default {
        name: "TopView",
        components: {},
        props: {
            durationNum: {
                type: Number,
                default: 0
            },
            questionTips: {
                type: String,
                default: ""
            },
            guideTips: {
                type: String,
                default: ""
            }
        },

        watch: {
            durationNum(value) {
                // if (value >= 10) {
                //     this.setViewFade(false)
                //     this.setViewFade(true)
                //     this.setTips("不知道说什么？", "戳我试试看...");
                // }
                // if (value < 10) {
                //     this.setViewFade(false)
                //     this.setViewFade(true)
                //     this.setTips("Hello~", "一起来体验吧");
                // }
            }
        },
        computed: {
            ...mapState(["isViewFade","chatLoading"])
        },
        data() {
            return {
                isClick: true, ////防止重复点击
                timer: "",
                count: 0,
                pageTips: "",
                pageTipsTo: "",
                isFade: false,
                clickable: false

            };

        },
        methods: {
            ...mapMutations([
                "setViewFade"
            ]),
            onAsk() {
                this.$emit("on-ask", "", "");
            },

            setTips(pageTips, pageTipsTo) {
                this.pageTips = pageTips;
                this.pageTipsTo = pageTipsTo;
            },
            onBlock() {
                let that = this;
                if (this.isClick) {
                    this.isClick = false;

                    this.setViewFade(false)
                    // this.setViewFade(true)

                    this.onAsk();

                    setTimeout(function () {
                        that.isClick = true;
                    }, 1000);
                }
            }

            //当戳一戳出现后，这里获取随机场景


        },
        created() {
                this.setViewFade(true)
                // this.setTips("Hi，我是小封！", "见到你真高兴，您可以试试：");
        },
        mounted() {

        },
        beforeDestroy() {
            clearInterval(this.timer);
        }
    };
</script>
<style lang="less" scoped>
    .ChatHeader {
        padding: .1rem .4rem .4rem .4rem;
        /*min-height: 3.2rem;*/
        .questionBox{
            min-height: 1.2rem;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: end;
            -ms-flex-align: end;
            align-items: flex-end;
            justify-content: flex-end;
            .questionTips{
                q{
                    display: inline-flex;
                }
            }
        }
        .loadingBox {
            padding-top: .4rem;
            margin-left: .2rem;

            .loadingImg {
                width: 3.6rem;
                height: 1.7rem;
            }
        }
        .topViewWrapper {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .pageTips-enter-active {
                transition: all 1s;
            }

            .pageTips-leave-active {
                transition: all .2s;
            }

            .pageTips-leave-to {
                opacity: 0;
            }

            .pageTips-enter {
                transform: translateX(30px);
            }


            .children {

                .childImg {
                    width: 1.5rem;
                    height:2.2rem;
                }

            }

            .contentCls {
                /*position: relative;*/
                padding-left: .4rem;


                .helloXf {

                    font-size: .5rem;
                    color: #fff;

                    .tipsTodo {

                        font-weight: 600;
                        margin: .26rem 0;
                    }

                    .guideTips {
                        margin: .20rem 0;
                        font-size: .40rem;
                        line-height: .62rem;
                        /*img{*/
                        /*    width: 36px;*/
                        /*}*/
                    }

                }



            }
        }

    }

</style>
